import { getSiteSettingsApiConfig } from '../config/actions';
/**
 * @internal
 */
export var getSiteFeaturesUrl = function (features) {
    var baseUrl = getSiteSettingsApiConfig().baseUrl;
    return baseUrl + "/" + getSiteFeaturesRelativeUrl(features);
};
/**
 * @internal
 */
export var getSiteFeaturesRelativeUrl = function (features) {
    var _a = getSiteSettingsApiConfig(), marketLocale = _a.marketLocale, siteContext = _a.siteContext;
    return "api/v1/feature" /* Feature */ + "/" + siteContext + "/" + marketLocale + "?features=" + features.join(',');
};
